export const labels: { [key: string]: string } = {
  expirationDate: 'Expiration date',
  dueDate: 'Due date',
  issueDate: 'Issue date',
  fileName: 'File name',
  fileType: 'File type',
  uploader: 'Uploaded by',
  uploadDate: 'Upload date',
  uploaderEmployer: 'Uploaded by',
  uploaderForeignNational: 'Uploaded by',
  uploaderTeamMember: 'Uploaded by',
  durationOfStatus: 'Exp. Date: D/S',
};

export default labels;
